<template>
  <div class="editTask">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_returnTask')}}</el-button>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="wid100" :label-width="require('@/config/enum').c_w9" :label-suffix="require('@/config/enum').c_colon">
        <!-- 任务名称 -->
        <el-form-item :label="$t('lang.lab_taskName')" prop="name">
          <el-input :disabled="editDisabled" v-model="ruleForm.name" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_taskName')" class="item-input" maxlength="50"></el-input>
        </el-form-item>
        <!-- 一级分类 -->
        <el-form-item :label="$t('lang.lab_typeName1')" prop="typeId1">
          <el-select :disabled="editDisabled" v-model="ruleForm.typeId1" :placeholder="$t('lang.lab_maintainOne')" @change="selectSecond">
            <el-option key :label="$t('lang.lab_maintainOne')" :value=0></el-option>
            <el-option
              v-for="item in maintainOneList"
              :key="item.id"
              :value="item.id"
              :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 二级分类 -->
        <el-form-item :label="$t('lang.lab_typeName2')">
          <el-select :disabled="editDisabled" v-model="ruleForm.typeId2" :placeholder="$t('lang.lab_maintainTwo')" @change="selectThird">
            <el-option key :label="$t('lang.lab_maintainTwo')" :value=0></el-option>
            <el-option
              v-for="item in maintainTwoList"
              :key="item.id"
              :value="item.id"
              :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 三级分类 -->
        <el-form-item :label="$t('lang.lab_typeName3')">
          <el-select :disabled="editDisabled" v-model="ruleForm.typeId3" :placeholder="$t('lang.lab_maintainThree')">
            <el-option key :label="$t('lang.lab_maintainThree')" :value=0></el-option>
            <el-option
              v-for="item in maintainThreeList"
              :key="item.id"
              :value="item.id"
              :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 是否稽查 -->
        <el-form-item :label="$t('lang.lab_taskInspect')" prop="isInspect">
          <el-radio-group v-model="ruleForm.isInspect">
            <el-radio :label="2" :disabled="editDisabled">{{$t('lang.lab_isInspectYes')}}</el-radio>
            <el-radio :label="0" :disabled="editDisabled">{{$t('lang.lab_isInspectNo')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 工期 -->
        <el-form-item :label="$t('lang.lab_workDay')" prop="workDay">
          <el-input-number :disabled="editDisabled" v-model="ruleForm.workDay" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_workDay')" controls-position="right" :min="1"></el-input-number>
        </el-form-item>
        <!-- 年 -->
        <el-form-item :label="$t('lang.lab_taskYear')" prop="yearList">
          <el-checkbox-group v-model="yearList" class="checkbox-group">
            <el-checkbox v-for="(item,index) in years" :key="index" :label="item.value" :disabled="editDisabled">
              {{item.value}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 月 -->
        <el-form-item :label="$t('lang.lab_taskMonth')" prop="monthList">
          <el-checkbox-group v-model="monthList" class="checkbox-group">
            <el-checkbox
              v-for="item in months"
              :key="item.id"
              :label="item.value"
              :disabled="editDisabled"
            >{{item.value}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 任务周期 -->
        <el-form-item :label="$t('lang.lab_workCycle')" prop="cycle">
          <el-select :disabled="editDisabled" v-model="ruleForm.cycle" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_workCycle')" @change="selectCycle">
            <el-option
              v-for="item in cycles"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 星期 -->
        <el-form-item :label="$t('lang.lab_taskWeek')" v-show="ruleForm.cycle === 1" prop="week">
          <el-checkbox-group v-model="ruleForm.week" class="checkbox-group">
            <el-checkbox
              v-for="item in weeks"
              :key="item.id"
              :label="item.value"
              :disabled="editDisabled"
            >{{item.value}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 天 -->
        <el-form-item :label="$t('lang.lab_taskDay')" v-show="ruleForm.cycle === 2" prop="day">
          <el-checkbox-group v-model="ruleForm.day" class="checkbox-group">
            <el-checkbox
              v-for="item in days"
              :key="item.id"
              :label="item.value"
              :disabled="editDisabled"
            >{{item.value}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 时 -->
        <el-form-item :label="$t('lang.lab_taskHour')" prop="hour">
          <el-checkbox-group v-model="ruleForm.hour" class="checkbox-group">
            <el-checkbox
              v-for="item in hours"
              :key="item.id"
              :label="item.value"
              :disabled="editDisabled"
            >{{item.value}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 分 -->
        <el-form-item :label="$t('lang.lab_taskMinute')">
          <el-checkbox-group v-model="minuteList" class="checkbox-group">
            <el-checkbox
              v-for="item in minutes"
              :key="item.id"
              :label="item.value"
              :disabled="editDisabled"
            >{{item.value}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item :label="$t('lang.lab_taskContent')" prop="content" class="input-width">
          <el-input :disabled="editDisabled" type="textarea" v-model="ruleForm.content" :autosize="{ minRows: 1, maxRows: 5}" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_taskContent')" maxlength="1000"></el-input>
        </el-form-item>
        <!-- 开始时间、结束时间 -->
        <el-form-item :label="$t('lang.lab_taskTime')" prop="time">
          <el-date-picker
            v-model="datevalues"
            type="datetimerange"
            :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')"
            :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"
            format="yyyy-MM-dd HH:mm"
            :disabled="editDisabled"
          ></el-date-picker>
        </el-form-item>
        <!-- 小区/负责人 
        <el-form-item :label="$t('lang.lab_taskVillage')"  :required="true" v-if="this.isFlag === false">
          <el-button @click="selectVillage()" :disabled="isVillage">{{$t('lang.lab_taskVillageList')}}</el-button>
        </el-form-item>-->
        <el-form-item :label="$t('lang.lab_taskGarden')" prop="gardenId">
          <el-select :disabled="editDisabled" v-model="ruleForm.gardenId" class="select">
            <el-option v-for="(item,index) in gardens" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 负责人 -->
        <el-form-item :label="$t('lang.lab_taskStaff')" prop="staff">
          <el-select :disabled="editDisabled" filterable v-model="ruleForm.dutyPerson" class="select">
            <el-option v-for="(item,index) in staffs" :key="index" :label="item.idNo" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 巡检标准 -->
        <el-form-item :label="$t('lang.lab_taskStandard')" :required="true">
          <el-button :disabled="editDisabled" @click="selectStandardList()">{{$t('lang.lab_taskStandardList')}}</el-button>
          <el-button :disabled="editDisabled" @click="selectHouseUintRoomList()" v-show="showItem">{{$t('lang.lab_houseUintRoomList')}}</el-button>
          <el-button :disabled="editDisabled" @click="addTaskStandard()">{{$t('lang.lab_addTaskStandard')}}</el-button>
          <br>
          <!-- 巡检标准列表 -->
          <el-table 
            :data="ruleForm.PatrolList" 
            class="table-position" 
            :row-class-name="tableRowClassName"
            :height="ruleForm.PatrolList.length > 0 ? require('@/config/enum').tableheight300  : require('@/config/enum').tableheight120">
            <el-table-column prop="patrolNamesList" :label="$t('lang.lab_taskStandard')+`/${PatrolCount}`"></el-table-column>
            <el-table-column prop="houseUnitRoomNameList" :label="$t('lang.lab_taskRoomInfo')" v-show="showItem"></el-table-column>
            <el-table-column prop="dutyPersonList" :label="$t('lang.lab_taskPerson')" v-if="(this.isFlag === false )&& showItem"></el-table-column>
            <el-table-column :label="$t('lang.lab_taskOperation')" width="100px">
              <template slot-scope="scope">
                <el-button :disabled="editDisabled" class="orange" v-if="scope.$index != -1" @click="deleteOne(scope.$index)">{{$t('lang.btn_delete')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- 巡检设备 -->
        <el-form-item :label="$t('lang.lab_taskDevice')" v-show="showItem">
          <el-button :disabled="editDisabled" @click="selectPatrolDevice()">{{$t('lang.lab_taskDeviceList')}}</el-button>
        </el-form-item>
        <!-- 巡检路线 -->
        <el-form-item :label="$t('lang.lab_taskRoute')" v-show="showItem">
          <el-button :disabled="editDisabled" @click="selectPatrolPointLine()">{{$t('lang.lab_taskRouteList')}}</el-button>
        </el-form-item>
        <!-- 所属小区 -->
        <el-form-item :label="$t('lang.lab_taskGarden')" prop="gardenId" v-if="this.isFlag === true">
          <el-select :disabled="editDisabled" v-model="ruleForm.gardenId" class="select">
            <el-option
              v-for="(item,index) in gardens"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 负责人 -->
        <el-form-item :label="$t('lang.lab_taskStaff')" prop="staff" v-if="this.isFlag === true">
          <el-select :disabled="editDisabled" filterable v-model="ruleForm.dutyPerson" class="select">
            <el-option
              v-for="(item,index) in staffs"
              :key="index"
              :label="item.idNo"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 上传附件 -->
        <el-form-item :label="$t('lang.lab_taskFileUpload')" class="upload-width" prop="file" ref="file" v-if="this.isFlag === false">
          <el-upload
            ref="upload"
            class="upload-demo"
            :on-remove="handleRemove"
            :on-change="handleSuccess"
            :on-exceed="outlimit"
            :on-error="uploadErr1"
            :limit='9'
            name="files"
            :action="require('@/config/enum').actionname"
            :auto-upload="false"
            
          >
            <el-button slot="trigger" size="small" type="primary">{{$t('lang.up_file')}}</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">{{$t('lang.btn_uploadtoserver')}}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_taskEditFileUpload')" v-if="this.isFlag === true">
          <a
            class="btnmar"
            target="_blank"
            :href="src.uri"
            v-for="(src,index) in ruleForm.jobFiles"
            :key="index"
            download
          >{{$t('lang.btn_taskEditFileUpload')+(index+1)}}</a>
        </el-form-item>
        <!-- 弹框 -->
        <el-dialog
          :visible.sync="isShow"
          :close-on-click-modal="false"
          center
          top="130px"
          width="600px"
          :title="title"
          @closed="handleDialogClosed"
          class="dialog-form"
        >
          <el-tabs 
            v-model="activeName" 
            type="border-card" 
            @tab-click="handleTabClick" 
            v-if="this.title === this.$i18n.t('lang.lab_taskStandardList')"
          >
            <el-tab-pane 
              v-for="(item,index) in maintainOneList"
              :key="index" 
              :label="item.name" 
              :name="item.id"
            >
              <el-form class="trees">
                <el-input v-model="keyword" placeholder="" class="item-input" maxlength="50"></el-input>
                <el-button type="primary" @click="searchPatrolStandard(item.id)">{{$t('lang.btn_search')}}</el-button>
                <br/><br/>
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('lang.lab_taskAllCheck')}}</el-checkbox>
                <el-checkbox-group v-model="patrolStandard" class="checkbox-line" @change="handleCheckedChange">
                  <el-checkbox
                    v-for="(item,index) in patrolStandardList"
                    :key="index"
                    :label="item.id"
                    :value="item.id"
                  >
                    <el-button type="text" @click="previewPatrolStandard(item.id)">{{item.name}}</el-button>
                  </el-checkbox>
                </el-checkbox-group>
              </el-form>
            </el-tab-pane>
          </el-tabs>
          <!-- 预览弹框 -->
          <el-dialog
            :visible.sync="isPreview"
            :close-on-click-modal="false"
            center
            top="130px"
            width="600px"
            :title="titlePreview"
            append-to-body
          >
            <!-- 巡检标准 预览弹框内容 -->
            <el-form
              ref="standardPreview"
              :model="standardPreview"
              class="form"
              :label-width="require('@/config/enum').c_ws4"
              :label-suffix="require('@/config/enum').c_colon"
              v-if="this.titlePreview === this.$i18n.t('lang.lab_taskStandardPreview')"
            >
              <el-form-item :label="$t('lang.lab_standardName')">{{this.standardPreview.name}}</el-form-item>
              <el-form-item :label="$t('lang.lab_standardMethod')">{{this.standardPreview.info}}</el-form-item>
              <el-form-item :label="$t('lang.lab_standardImg')">
                <viewer :images="standardPreview.urls">
                  <img v-for="(src,index) in standardPreview.urls" 
                  :src="src"
                  :key="index"
                  class="img">
                </viewer>
              </el-form-item>
            </el-form>
            <!-- 巡检路线 预览弹框内容 -->
            <el-form
              ref="routePreview"
              :model="routePreview"
              class="form"
              :label-width="require('@/config/enum').c_w6"
              :label-suffix="require('@/config/enum').c_colon"
              v-if="this.titlePreview === this.$i18n.t('lang.lab_taskRoutePreview')"
            >
              <el-form-item :label="$t('lang.lab_standardName')">{{this.routePreview.name}}</el-form-item>
              <el-form-item :label="$t('lang.lab_patrol_point_order')">{{this.routePreview.patrolPointLineSeq}}</el-form-item>
              <el-form-item :label="$t('lang.lab_patrol_point_group')">{{this.routePreview.patrolPointLinePerson}}</el-form-item>
              <el-form-item :label="$t('lang.lab_patrol_point')">
                <img
                  v-for="(src,index) in this.routePreviewUrls"
                  :src="src"
                  :key="index"
                  class="img"
                  @click="showGraph(src)"
                />
              </el-form-item>
            </el-form>
          </el-dialog>
          <el-scrollbar>
            <!-- 巡检设备 弹框内容 -->
            <el-form class="trees" v-if="this.title === this.$i18n.t('lang.lab_taskDeviceList')">  
              <el-checkbox-group v-model="patrolDevice" class="checkbox-line">
                <el-checkbox
                  v-for="(item,index) in patrolDeviceList"
                  :key="index"
                  :label="item.id"
                  :value="item.id"
                  class="option-text-patrolDevice"
                >
                  <span class="option-color">{{item.name}}</span>
                </el-checkbox>
              </el-checkbox-group>
            </el-form>
            <!-- 巡检路线 弹框内容 -->
            <el-form class="trees" v-if="this.title === this.$i18n.t('lang.lab_taskRouteList')">  
              <el-radio-group v-model="ruleForm.patrolPointLine" class="checkbox-line">
                <el-radio
                  v-for="(item,index) in patrolPointLineList"
                  :key="index"
                  :label="item.id"
                  :value="item.id"
                  class="option-text-patrolPointLine"
                >
                  <el-button type="text" @click="previewPatrolPointLine(item.id)">{{item.name}}</el-button>
                </el-radio>
              </el-radio-group>
            </el-form>
          </el-scrollbar>
        </el-dialog>
        <!-- 小区/负责人 弹框 -->
        <el-dialog
          :visible.sync="isShowGardenStaff"
          :close-on-click-modal="false"
          center
          top="130px"
          width="600px"
          :title="titleGardenStaff"
          @closed="handleGardenStaffDialogClosed"
          class="dialog-form"
        >
          <el-scrollbar>
            <el-form class="trees"> 
              <el-tree
                node-key="ssKey"
                ref="treeGardenStaff"
                :data="gardenStaffList"
                :show-checkbox="true" 
                :check-strictly="true" 
                :accordion="true" 
                :check-on-click-node="true" 
                :props="defaultProps1"
                @check="clickDeal"
              ></el-tree> 
            </el-form>
          </el-scrollbar>
        </el-dialog>
        <!-- 楼号\单元\房间号 弹框 -->
        <el-dialog
          :visible.sync="isShowHouseUnitRoom"
          :close-on-click-modal="false"
          center
          top="130px"
          width="600px"
          :title="titleHouseUnitRoom"
          @closed="handleHouseUnitRoomDialogClosed"
          class="dialog-form"
        >
          <el-scrollbar>
            <el-form class="trees">
              <el-tree
                node-key="id"
                ref="treeHouseUnitRoom"
                :data="theHURList"
                :show-checkbox="true" 
                :accordion="true" 
                :check-on-click-node="true" 
                :props="defaultProps2"
              ></el-tree>
            </el-form>
          </el-scrollbar>
        </el-dialog>
        <!-- 点位弹框 -->
        <el-dialog
          :visible.sync="isImg"
          :close-on-click-modal="false"
          center
          :title="titlePoint"
          top="130px"
          width="750px"
        >
          <div ref="imageTofile">
            <div v-for="(item, index) in sign" :key="index.pointId">
              <el-popover placement="top" trigger="hover" :title="pointName">
                <p class="height_all">{{item.msg}}</p>
                <div style="text-align: right; margin: 0; bottom: 0;">
                  <el-button
                    type="success"
                    size="mini"
                    @click="seeQrImg(item.pointId, item.msg)"
                  >{{$t('lang.lab_seeQrCodes')}}</el-button>
                </div>
                <div
                  :style="'left:' + item.left + ';' + 'top:' + item.top + ';' + 'background-image:url(' + item.ptypecss + ');'"
                  class="pointImg"
                  slot="reference"
                ></div>
              </el-popover>
              <div :style="'left:' + item.left + ';' + 'top:' + item.top " class="pointSpan">
                <span>{{item.msg}}</span>
              </div>
            </div>
            <img :src="getImgUrl" class="getImg" />
          </div>
        </el-dialog>
        <!-- 二维码弹框 -->
        <el-dialog
          :visible.sync="showQr"
          :close-on-click-modal="false"
          center
          top="130px"
          width="320px"
          height="320px"
          :title="QrTitle"
          @closed="handleDialogClosed"
        >
         <vue-qr :text="qrText + ''" :title="'{id:' + qrShowPointId +  '}'" :size="300"></vue-qr>
        </el-dialog>
        <el-button v-show="this.isPatrol == 0" class="btn-first" @click="resetForm('ruleForm')" :disabled="editDisabled">{{$t('lang.btn_rest')}}</el-button>
        <el-button v-show="this.isPatrol == 0" class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="total===0">{{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:editTask
 *@Description:任务管理-编辑/新增
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-26
 */
export default {
  data() {
    var validYear = (rule, value, callback) => {
        // console.log(value,this.yearList) 
        if (this.yearList.length == 0) {
          return callback(new Error(this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_taskYear')))
        } else {
          callback()
        }
      }
      var validMonth = (rule, value, callback) => {
        // console.log(value,this.monthList) 
        if (this.monthList.length == 0) {
          return callback(new Error(this.$i18n.t('lang.lab_please_Select') + '月'))
        } else {
          callback()
        }
      }
    return {
      QrTitle: '', // 查看二维码的标题
      getImgUrl: '', // 图片的URL
      qrText: '', // 二维码显示的内容
      qrShowPointId: '', // 绑定的ID
      isDisabled: 0, // ruleForm保存的可点击
      isDisabled_urlList: 0, 
      isDisabled_patrolDevice: 0, 
      isDisabled_minuteList: 0, 
      isDisabled_yearList: 0,
      isDisabled_monthList: 0,  
      isDisabled_datevalues: 0, 
      editDisabled: false, // 是否有修改权限
      isVillage: true, // 巡检表格显示
      isFlag: false, // 编辑:true 新增：false
      isPatrol: 0, // 0是从列表进入，1是从其他进入
      isShow: false, // 弹框开关
      isPreview: false, // 弹框预览开关
      isShowGardenStaff: false, // 小区/负责人弹框开关
      isShowHouseUnitRoom: false, // 楼号\单元号\房间号弹框开关
      isImg: false, // 点位弹框显示
      showQr: false, // 查看二维码的弹框
      checkAll: false, // 弹框全选、全不选
      isIndeterminate: false, // 弹框checkbox的不确定状态
      showItem: true, // 控制巡检设备、巡检路线、楼号\单元号\房间号显示
      title: '', // 弹框title
      titlePreview: '', // 弹框预览title
      titleGardenStaff: '', // GardenStaff弹框title
      titleHouseUnitRoom: '', // HouseUnitRoom弹框title
      titlePoint: this.$i18n.t('lang.lab_taskTitlePoint'), // 弹框点位图title
      gardenId: '', // 进入页面时的小区
      garden: '', // 通过小区/负责人选择的小区
      gardens: [], // 小区集合
      staffs: [], // 责任人集合
      maintainOneList: [], // 报事一级分类list
      maintainTwoList: [], // 报事二级分类list
      maintainThreeList: [], // 报事三级分类list
      years: [], // 年list
      months: [], // 月list
      weeks: [], // 周list
      days: [], // 天list
      hours: [], // 时间list
      minutes: [], // 分钟list
      yearList: [], // 年checkBoxlist
      monthList: [], // 月checkBoxlist
      minuteList: [], // 分钟checkBoxlist
      maintainType: 1, // 报事级别
      maintainType1: '', // 报事一级id
      datevalues: [], // 开始结束时间绑定值
      gardenList: [], // 小区绑定值
      staffList: [], // 负责人绑定id集合
      staffNameList: [], // 负责人绑定Name集合
      gardenStaffList: [], // 小区/负责人列表
      gardenStaffListBase: [], // 小区/负责人base列表
      patrolStandard: [], // 巡检标准绑定值
      patrolStandardName: [], // 巡检标准绑定值的对应名称
      patrolStandardList: [], // 巡检标准列表
      patrolStandardIdList: [], // 巡检标准列表的id集合
      theHURListBase: [], // 楼号\单元号\房间号base列表
      theHURList: [], // 楼号\单元号\房间号列表
      theHURName: [], // 楼号\单元号\房间号选择名称集合
      theHURSelected: [], // 楼号\单元号\房间号选择集合
      patrolNameList: [], // 巡检标准选中过tab的名字集合
      houseId: [], // check楼号id集合
      unitId: [], // check单元号id集合
      roomId: [], // check房间号id集合
      patrolDevice: [], // 巡检设备绑定值
      patrolDeviceList: [], // 巡检设备列表
      patrolPointLineList: [], // 巡检路线列表
      activeName: '', // 巡检标准tab选择绑定值
      standardPreview: [], // 巡检标准预览列表
      routePreview: [], // 巡检路线预览列表
      routePreviewUrls: [], // 巡检线路弹窗图片
      sign: [], // 获取原来图片添加点位的参数数组
      fileList: [], // 附件上传绑定
      urlList: [], // url集合
      cron: '', // 时间数据组的字符串
      yearCron: '*',
      mouthCron: '*', 
      weekCron: '?', 
      dayCron: '*', 
      hourCron: '*', 
      minuteCron: '0', 
      ruleForm: {
        PatrolList: [], // 巡检标准的列表
        content: '', // 内容
        createPerson: '', // 由我发起
        day: [], // 日
        device: '', // 巡检设备
        dutyPerson: '', // 责任人
        endTs: '', // 计划结束时间
        gardenId: '', // 小区Id
        hour: [], // 时
        houseId: '', // 楼号
        isInspect: 0, // 是否稽查：0否 2是
        jobFiles: [], // 附件
        minute: '', // 分
        mouth: '', // 月
        name: '', // 任务名称
        patrolPointLine: '', // 巡检路线
        patrolStandard: [], // 巡检标准
        roomId: '', // 房间号
        startTs: '', // 计划开始时间
        typeId1: 0, // 报事一级
        typeId2: 0, // 报事二级
        typeId3: 0, // 报事三级
        unitId: '', // 单元号
        week: [], // 周
        workDay: '', // 工期
        year: '', // 年
        cycle: 2, // 任务周期，默认天
      }, // 编辑、新建页面内容
      defaultProps1: {
        children: 'nodes',
        label: 'text',
      }, // 小区/负责人treeGardenStaff数据
      defaultProps2: {
        children: 'nodes',
        label: 'text',
      }, // 楼号\单元号\房间号treeHouseUnitRoom数据
      rules: {
        name: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_taskName'), trigger: 'blur' }],
        content: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_taskContent'), trigger: 'blur' }],
        typeId1: [{ required: true, message: this.$i18n.t('lang.lab_maintainOne'), trigger: 'change' }],
        yearList: [{ required: true, validator: validYear, trigger: 'change' }],
        monthList: [{ required: true, validator: validMonth, trigger: 'change' }],
        week: [{ required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_taskWeek'), trigger: 'change' }],
        day: [{ required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_taskDay'), trigger: 'change' }],
        hour: [{ required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_taskHour'), trigger: 'change' }],
      },
      cycles: this.$i18n.t('lang.EditTask_cycles'), // 任务周期
      PatrolCount: 0, // 标准数量
      keyword: '' // 巡检标准查询框
    }
  },
   // #8449 add
  destroyed() {
    this.taskManageForm = {
        ruleForm: JSON.stringify(this.ruleForm), 
        patrolDevice: JSON.stringify(this.patrolDevice), // 红方观点
        yearList: JSON.stringify(this.yearList),
        monthList: JSON.stringify(this.monthList), 
        minuteList: JSON.stringify(this.minuteList), 
        datevalues: JSON.stringify(this.datevalues), 
        urlList: JSON.stringify(this.urlList),
        saveData: this.saveData,
        saveData_patrolDevice: this.saveData_patrolDevice,
        saveData_yearList: this.saveDsaveData_yearListata,
        saveData_monthList: this.saveDsaveData_monthListata,
        saveData_minuteList: this.saveData_minuteList,
        saveData_datevalues: this.saveData_datevalues,
        saveData_urlList: this.saveData_urlList,
        patrolDeviceList: this.patrolDeviceList,
        patrolPointLineList: this.patrolPointLineList,
        editDisabled: this.editDisabled,
        PatrolCount: this.PatrolCount
    }
    window.localStorage.setItem('taskManagementForm', JSON.stringify(this.taskManageForm))
  },
  created() {
    // 获取用户Id和权限
    this.userDataId = this.$store.getters.staffId
    this.userPermission = this.$store.getters.permission
    // 获取当前小区
    this.gardenId = this.$store.getters.gardenId
    // 接受页面数据
    this.isFlag = this.$route.query.flag
    this.isPatrol = this.$route.query.isPatrol
    // 初始获取数据
    this.getValueListByCode()
    this.maintains()
    this.maintainTypes(2, this.ruleForm.typeId1)
    this.maintainTypes(3, this.ruleForm.typeId2)
    this.getGardenStaff()
    // 杜，新增2
    this.getGarden()
    this.getStaff()
    // #8449 add
    if (window.localStorage.getItem('taskManagementForm')) {
      this.taskManageForm = JSON.parse(window.localStorage.getItem('taskManagementForm'))
      this.ruleForm = JSON.parse(this.taskManageForm.ruleForm)
      this.datevalues = JSON.parse(this.taskManageForm.datevalues)
      this.minuteList = JSON.parse(this.taskManageForm.minuteList)
      this.yearList = JSON.parse(this.taskManageForm.yearList)
      this.monthList = JSON.parse(this.taskManageForm.monthList)
      this.urlList = JSON.parse(this.taskManageForm.urlList)
      this.patrolDevice = JSON.parse(this.taskManageForm.patrolDevice)
      this.saveData = this.taskManageForm.saveData
      this.saveData_datevalues = this.taskManageForm.saveData_datevalues
      this.saveData_minuteList = this.taskManageForm.saveData_minuteList
      this.saveData_patrolDevice = this.taskManageForm.saveData_patrolDevice
      this.saveData_urlList = this.taskManageForm.saveData_urlList
      this.garden = this.ruleForm.gardenId
      this.editDisabled = this.taskManageForm.editDisabled
      this.PatrolCount = this.taskManageForm.PatrolCount
      this.maintainTypes(2, this.ruleForm.typeId1)
      this.maintainTypes(3, this.ruleForm.typeId2)    
      this.getPatrolDevice()
      this.getPatrolPointLine()
      this.getHouseUnitRoomList()     
    } else {
      // 判断编辑与新增
      if (this.isFlag) {
        this.id = this.$route.query.id
        this.getData()
        // 原，2
        // this.getGarden()
        // this.getStaff()
      }
    }
  },
  computed: {
    total: function() {
      // console.log('isDisabled:', this.isDisabled, this.isDisabled_urlList, this.isDisabled_patrolDevice, this.isDisabled_minuteList, this.isDisabled_monthList, this.isDisabled_datevalues)
      return this.isDisabled + this.isDisabled_urlList + this.isDisabled_patrolDevice + this.isDisabled_minuteList + this.isDisabled_monthList + this.isDisabled_yearList + this.isDisabled_datevalues
    }
  },
  watch: {
    ruleForm: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = 0
        } else {
          // 变了
          this.isDisabled = 1
          if (this.ruleForm.PatrolList) {
            if (this.ruleForm.PatrolList.length > 0) {
              this.isVillage = true
            } else {
              this.isVillage = false
            }
          }
        }
      },
      deep: true,
      immediate: true
    },
    datevalues: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_datevalues) {
          // 没变
          this.isDisabled_datevalues = 0
        } else {
          // 变了
          this.isDisabled_datevalues = 1
        }
      },
      deep: true,
      immediate: true
    },
    yearList: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData_yearList) {
            // 没变
            this.isDisabled_yearList = 0
          } else {
            // 变了
            this.isDisabled_yearList = 1
          }
        },
        deep: true,
        immediate: true
      },
    monthList: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_monthList) {
          // 没变
          this.isDisabled_monthList = 0
        } else {
          // 变了
          this.isDisabled_monthList = 1
        }
      },
      deep: true,
      immediate: true
    }, 
    minuteList: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_minuteList) {
          // 没变
          this.isDisabled_minuteList = 0
        } else {
          // 变了
          this.isDisabled_minuteList = 1
        }
      },
      deep: true,
      immediate: true
    },
    patrolDevice: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_patrolDevice) {
          // 没变
          this.isDisabled_patrolDevice = 0
        } else {
          // 变了
          this.isDisabled_patrolDevice = 1
        }
      },
      deep: true,
      immediate: true
    },
    urlList: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_urlList) {
          // 没变
          this.isDisabled_urlList = 0
        } else {
          // 变了
          this.isDisabled_urlList = 1
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    // 上传文件的断网
    uploadErr1() {
        if (!navigator.onLine || window.navigator.onLine === false) {
            const loading = this.$loading()
            setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
            }, 500)
        }
    },
    // 获取动态List
    getValueListByCode() {
      /* 获取年 */
        var nowDate = new Date()
        for (var i = 0; i < 2; i++) {
          var dateInt = nowDate.getFullYear() + i
          var dateStr = dateInt.toString()
          var code = i.toString()
          this.years.push({
            'id': i,
            'value': dateStr,
            'code': code
          })
        }
        console.log(this.years)
      let list = [{ name: 'mouths', id: 0 }, { name: 'weeks', id: 1 }, { name: 'days', id: 2 }, { name: 'hours', id: 3 }, { name: 'minutes', id: 4 }]
      for (let index = 0; index < list.length; index++) {
        this.$get(`/getValueListByCode?code=${list[index].name}`).then(
          res => {
            if (res && res.errCode === 0) {
              switch (list[index].id) {
                case 0:
                  this.months = res.result
                  break
                case 1:
                  this.weeks = res.result
                  break
                case 2:
                  this.days = res.result
                  break
                case 3:
                  this.hours = res.result
                  break
                case 4:
                  this.minutes = res.result
                  break
                default:
                  break
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      }
    },
    // 获取小区/责任人List
    getGardenStaff() { 
      this.$get(`/getGardenStaff?gardenId=${this.gardenId}`).then(
        res => {
          if (res && res.errCode === 0) {
            this.gardenStaffListBase = res.list
            // 将houseId、unitId转成id
            // 添加sskey字段作为node-key，避免一人(同id)负责两个小区的情况
            let tempList = res.list 
            let newList = [] 
            let count = 1
            for (let index = 0; index < tempList.length; index++) {
              var house = {
                id: tempList[index].houseId,
                text: tempList[index].text,
                nodes: [],
                ssKey: count
              }
              newList.push(house)
              count++
              if (tempList[index].nodes && tempList[index].nodes.length > 0) {
                for (let j = 0; j < tempList[index].nodes.length; j++) {
                  var newnewValue = {
                    id: tempList[index].nodes[j].unitId,
                    text: tempList[index].nodes[j].text,
                    ssKey: count
                  }                  
                  newList[index].nodes.push(newnewValue)
                  count++
                }
              }
            }            
            this.gardenStaffList = newList
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    searchPatrolStandard(id) {
      this.getPatrolStandard(id, this.keyword)
    },
    // 获取巡检标准List
    getPatrolStandard(id, keyword) {
      this.patrolStandardList = []
      this.patrolStandardIdList = []
      this.$get(`/patrolStandard/?maintainType1=${id}&keyword=${keyword}`).then(
        res => {
          if (res && res.errCode === 0) {
            this.patrolStandardList = res.list
            for (let index = 0; index < this.patrolStandardList.length; index++) {
              this.patrolStandardIdList.push(this.patrolStandardList[index].id)
              this.collectName(id, this.patrolStandardList[index].id, this.patrolStandardList[index].name)
            }
            this.statusCheckAll(this.patrolStandard)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 修正全选按钮状态
    statusCheckAll(value) {
      var count = 0
      this.patrolStandardIdList.forEach(element => {
        let index = value.findIndex(item => item === element)
        if (index != -1) {
          count++
        } 
      })

      this.checkAll = (this.patrolStandardIdList.length > 0 && count === this.patrolStandardIdList.length)
      this.isIndeterminate = (count > 0 && count < this.patrolStandardIdList.length)
    },
    // 集合选过的tab里巡检标准名称
    collectName(type, id, name) {
      if (this.patrolNameList.length > 0) {
        let temp = this.patrolNameList.findIndex(item => item.id === id)
        if (temp === -1) {
          let obj = {}
          obj.type = type
          obj.id = id
          obj.name = name
          this.patrolNameList.push(obj)
        }              
      } else {
        let obj = {}
        obj.type = type
        obj.id = id
        obj.name = name
        this.patrolNameList.push(obj)              
      }
    },
    // 获取楼号\单元号\房间号List
    getHouseUnitRoomList() {
      if (this.garden === undefined || this.garden === '') {
        this.$get(`/getHURList`).then(
        res => {
          if (res && res.errCode === 0) {
            this.theHURListBase = res.list
            // 将houseId、unitId、roomId转成id，为了在treeHouseUnitRoom中显示
            let tempList = []
            tempList = res.list
            let temp = JSON.stringify(tempList).replace(/houseId/g, 'id')
            temp = temp.replace(/unitId/g, 'id')
            temp = temp.replace(/roomId/g, 'id')
            this.theHURList = JSON.parse(temp)
          }
        },
        error => {
          this.$message.error(error)
        })
      } else {
        this.$get(`/getHURList?gardenId=${this.garden}`).then(
          res => {
            if (res && res.errCode === 0) {
              this.theHURListBase = res.list
              // 将houseId、unitId、roomId转成id，为了在treeHouseUnitRoom中显示
              let tempList = []
              tempList = res.list
              let temp = JSON.stringify(tempList).replace(/houseId/g, 'id')
              temp = temp.replace(/unitId/g, 'id')
              temp = temp.replace(/roomId/g, 'id')
              this.theHURList = JSON.parse(temp)
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      }
    },
    // 获取巡检设备List
    getPatrolDevice() {
      this.$get(`/device/?gardenId=${this.gardenId}&pageNo=1&pageSize=999`).then(
        res => {
          if (res && res.errCode === 0) {
            this.patrolDeviceList = res.list
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取巡检路线List
    getPatrolPointLine() {
      this.$get(`patrolPointLine?GardenId=${this.garden}&PlanarGraphId=0&PatrolTypeId=0&pageNo=1&pageSize=999`).then(
        res => {
          if (res && res.errCode === 0) {
            this.patrolPointLineList = res.list
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取小区List
    getGarden() {
      this.$get(`/gardens?gardenId=${this.$store.getters.gardenId}`).then(
        res => {
          if (res && res.errCode === 0) {
            this.gardens = res.list
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取责任人List
    getStaff() {
      // 杜，修改下一接口参数（删除‘gardenId=${this.gardenId}&’，负责人不被小区限制）
      // this.$get(`staffs?isLeave=0&pageNo=1&pageSize=9999`).then(
      this.$get(`staffsNoPage?groupId=${this.$store.getters.groupId}`).then(
        res => {
          if (res && res.errCode === 0) {
            this.staffs = res.list
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取报事分类一级List
    maintains() {
      this.$get(`/maintainTypes?type=1&pageNo=1&pageSize=999&gardenId=${this.gardenId}`).then(
        res => {
          if (res && res.errCode === 0) {
            if (this.maintainType === 1) {
              console.log(res)
              this.maintainOneList = res.list
              if (this.maintainOneList.length > 0) {
                 this.maintainType1 = this.maintainOneList[0].id
                 this.activeName = this.maintainType1
                this.getPatrolStandard(this.maintainType1)
              }
            }
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 通过报事级别和id查询下一级别list
    maintainTypes(type, id) {
      if (id === '' || id === null || id === 0) return
      this.$get(`/maintainTypes?type=${type}&Pid=${id}&pageNo=1&pageSize=999`).then(
        res => {
          if (res && res.errCode === 0) {
            if (type === 2) {
              this.maintainTwoList = res.list
            } else if (type === 3) {
              this.maintainThreeList = res.list
            }
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 通过报事一级别查询二级下拉list
    selectSecond() {
      this.maintainType = 2
      this.maintainTwoList = []
      this.maintainThreeList = []
      this.ruleForm.typeId2 = 0
      this.ruleForm.typeId3 = 0
      this.maintainTypes(this.maintainType, this.ruleForm.typeId1)
    },
    // 通过报事二级别查询三级下拉list
    selectThird() {
      this.maintainType = 3
      this.maintainThreeList = []
      this.ruleForm.typeId3 = 0
      this.maintainTypes(this.maintainType, this.ruleForm.typeId2)
    },
    // 选择任务周期
    selectCycle() {
      if (this.ruleForm.cycle === 1) {
        this.ruleForm.day = []
        this.rules.day[0].required = false
        this.rules.week[0].required = true
        this.$refs.ruleForm.validateField('week')
      } else if (this.ruleForm.cycle === 2) {
        this.ruleForm.week = []
        this.rules.week[0].required = false
        this.rules.day[0].required = true
        this.$refs.ruleForm.validateField('day')
      }
    },
    // id查询详情
    getData() {
      this.$get(`/quartzJobById/` + this.id).then(
        res => {
          if (res && res.errCode === 0) {
            if (res.createPerson === this.userDataId || this.userPermission === '*') {
              this.editDisabled = false
            } else {
              this.editDisabled = true
            }
            this.ruleForm = res
            this.garden = this.ruleForm.gardenId
            // 获取报事二级列表
            this.maintainTypes(2, this.ruleForm.typeId1)
            // 获取报事三级列表
            this.maintainTypes(3, this.ruleForm.typeId2)
            this.getPatrolDevice()
            this.getPatrolPointLine()
            this.getHouseUnitRoomList()
            // 巡检标准列表
            if (this.ruleForm.PatrolList) {
              for (let i = 0; i < this.ruleForm.PatrolList.length; i++) {
                if (this.ruleForm.PatrolList[i].houseUnitRoomList) {
                  let array = []
                  let temp = this.ruleForm.PatrolList[i].houseUnitRoomList
                  for (let j = 0; j < temp.length; j++) {
                    if (temp[j] && temp[j].roomName) {
                      array.push(temp[j].roomName)
                    }
                  }
                  this.ruleForm.PatrolList[i].houseUnitRoomNameList = array.join(' ')
                }
                if (this.ruleForm.PatrolList[i].patrolNameList) {
                  let array = []
                  let temp = this.ruleForm.PatrolList[i].patrolNameList
                  for (let j = 0; j < temp.length; j++) {
                      array.push(temp[j])
                    }
                  this.ruleForm.PatrolList[i].patrolNamesList = array.join(' ')
                  this.PatrolCount = this.PatrolCount + temp.length
                }
              }
            } else {
              this.ruleForm.PatrolList = []
            } 
            // 附件
            this.fileList = []
            if (this.ruleForm.jobFiles && this.ruleForm.jobFiles != null) {
              if (this.ruleForm.jobFiles.length > 0) {
                for (let j = 0; j < this.ruleForm.jobFiles.length; j++) {
                  this.fileList.push({
                    name: '',
                    url: this.ruleForm.jobFiles[j].uri
                  })
                }                
              }
            }   
            this.urlList = []
            for (let i = 0; i < this.fileList.length; i++) {
              this.urlList.push(this.fileList[i].url)
            }
            // 巡检设备
            this.patrolDevice = [] 
            if (this.ruleForm.device != '') {
              let device = [] 
              device = this.ruleForm.device.split(',')
              for (let i = 0; i < device.length; i++) {
                this.$set(this.patrolDevice, i, Number(device[i]))
              } 
            }
            // 巡检路线
            if (this.ruleForm.patrolPointLine != '') {
              this.ruleForm.patrolPointLine = Number(this.ruleForm.patrolPointLine)
            }            
            // 是否稽查
            if (this.ruleForm.isInspect === null) {
              this.ruleForm.isInspect = 0
            }
            // 年
              this.yearList = [] // 年checkBoxlist
              if (this.ruleForm.year === '?' || this.ruleForm.year === '*' || this.ruleForm.year === null) {} else {
                let year = []
                year = this.ruleForm.year.split(',')
                for (let a = 0; a < year.length; a++) {
                  this.$set(this.yearList, a, year[a])
                }
              }
            // 月
            this.monthList = [] // 月checkBoxlist
            if (this.ruleForm.mouth === '?' || this.ruleForm.mouth === '*' || this.ruleForm.mouth === null) {
            } else {
              let month = [] 
              month = this.ruleForm.mouth.split(',')
              for (let a = 0; a < month.length; a++) {
                this.$set(this.monthList, a, month[a])
              }    
            }
            // 日
            if (this.ruleForm.day === '?' || this.ruleForm.day === '*' || this.ruleForm.day === null) {
              this.ruleForm.day = []
            } else {
              if (this.ruleForm.day.indexOf(',') != -1) {
                this.ruleForm.day = this.ruleForm.day.split(',')
              } else {
                let tempDay = []
                tempDay.push(this.ruleForm.day)
                this.ruleForm.day = tempDay
              }
            } 
            // 周
            if (this.ruleForm.week === '?' || this.ruleForm.week === '*' || this.ruleForm.week === null) {
              this.ruleForm.cycle = 2 // 任务周期:天
              this.ruleForm.week = []
            } else {
              this.ruleForm.cycle = 1 // 任务周期:星期
              if (this.ruleForm.week.indexOf(',') != -1) {
                this.ruleForm.week = this.ruleForm.week.split(',')
                for (let count = 0; count < this.ruleForm.week.length; count++) {
                  let index = this.weeks.findIndex(item => item.code === this.ruleForm.week[count])
                  if (index != -1) {
                    this.ruleForm.week[count] = this.weeks[index].value
                  }
                }    
              } else {
                let tempWeek = []
                tempWeek.push(this.ruleForm.week)
                this.ruleForm.week = tempWeek
              }
            }  
            // 时
            if (this.ruleForm.hour === '?' || this.ruleForm.hour === '*' || this.ruleForm.hour === null) {
              this.ruleForm.hour = []
            } else {
              if (this.ruleForm.hour.indexOf(',') != -1) {
                this.ruleForm.hour = this.ruleForm.hour.split(',')
              } else {
                let tempHour = []
                tempHour.push(this.ruleForm.hour)
                this.ruleForm.hour = tempHour
              }
            } 
            // 分
            this.minuteList = [] // 分checkBoxlist
            if (this.ruleForm.minute === '?' || this.ruleForm.minute === '*' || this.ruleForm.minute === null) {
            } else {
              let minute = [] 
              minute = this.ruleForm.minute.split(',')
              for (let e = 0; e < minute.length; e++) {
                if (minute[e] === '0') {
                  minute[e] = '00'
                }
                this.$set(this.minuteList, e, minute[e])
              }              
            } 
            // 转换时间
            this.datevalues = []
            if (this.ruleForm.startTs && this.ruleForm.startTs != null && this.ruleForm.endTs && this.ruleForm.endTs != null) {
              this.datevalues[0] = this.ruleForm.startTs
              this.datevalues[1] = this.ruleForm.endTs
              this.$set(this.datevalues, 0, this.ruleForm.startTs) 
              this.$set(this.datevalues, 1, this.ruleForm.endTs)               
            }
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.saveData = JSON.stringify(this.ruleForm)
            this.saveData_patrolDevice = JSON.stringify(this.patrolDevice)
            this.saveData_yearList = JSON.stringify(this.yearList)
            this.saveData_monthList = JSON.stringify(this.monthList)
            this.saveData_minuteList = JSON.stringify(this.minuteList)
            this.saveData_datevalues = JSON.stringify(this.datevalues)
            this.saveData_urlList = JSON.stringify(this.urlList)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取 楼号\单元号\房间号 名称集合
    getHouseUnitRoomName() {
      let checked = this.$refs.treeHouseUnitRoom.getCheckedNodes()
      this.theHURName = []
      let aaa = []
      let bbb = []
      let ccc = []
      let houseName
      let unitName
      for (let index in checked) {
        let data = this.$refs.treeHouseUnitRoom.getNode(checked[index])
          console.log(data)
          if (data.level == 1 && data.childNodes == 0) {
            aaa.push(data.data.text)
            // 用于显示数据
            houseName = data.data.text
            this.theHURName.push(houseName)
            // 用于保存数据
            let obj = {}
            obj.roomId = data.data.id
            obj.roomName = houseName
            obj.type = 1
            this.theHURSelected.push(obj)
          }
          if (data.level == 2 && data.childNodes == 0) {
            bbb.push(data.data.text)
            // 用于显示数据
            let nameString
            houseName = data.parent.label
            unitName = data.data.text
            nameString = houseName + '-' + unitName
            this.theHURName.push(nameString)
            // 用于保存数据
            let obj = {}
            obj.roomId = data.data.id
            obj.roomName = houseName + '-' + unitName
            obj.type = 2
            this.theHURSelected.push(obj)
          }
          if (data.level == 3) {
            ccc.push(data.data.text)
            // 用于显示数据
            let nameString
            houseName = data.parent.parent.label
            unitName = data.parent.label
            nameString = houseName + '-' + unitName + '-' + data.data.text
            this.theHURName.push(nameString)
            // 用于保存数据
            let obj = {}
            obj.roomId = data.data.id
            obj.roomName = houseName + '-' + unitName + '-' + data.data.text
            obj.type = 3
            this.theHURSelected.push(obj)
          }
        // if (checked[index].nodes) {
        // } else {
        //   // 获取当先node data
        //   let data = this.$refs.treeHouseUnitRoom.getNode(checked[index])
        //   // 用于显示数据
        //   let nameString
        //   houseName = data.parent.parent.label
        //   unitName = data.parent.label
        //   nameString = houseName + '-' + unitName + '-' + checked[index].text
        //   this.theHURName.push(nameString)
        //   // 用于保存数据
        //   let obj = {}
        //   obj.roomId = checked[index].id
        //   obj.roomName = houseName + '-' + unitName + '-' + checked[index].text
        //   this.theHURSelected.push(obj)
        // }
      }
    },
    // check小区\负责人
    getCheckedGradanStaff() {
      this.getCheckedUnit()
      if (this.staffList.length > 1) {
        this.showItem = false
        this.patrolDevice = []
        this.ruleForm.patrolPointLine = ''
      } else {
        this.showItem = true
        if (this.staffList.length > 0) {
          this.patrolDevice = []
          this.ruleForm.patrolPointLine = ''
          this.patrolDeviceList = []
          this.patrolPointLineList = []
          this.theHURList = []
          this.getPatrolDevice()
          this.getPatrolPointLine()
          this.getHouseUnitRoomList()
        }
      }
    },
    // 获取小区\负责人namelist
    getCheckedUnit() {
      this.gardenList = []
      this.staffList = []
      this.staffNameList = []
      let checked = this.$refs.treeGardenStaff.getCheckedNodes()
      // flag 标记当前选择的小区数
      let flag = 0
      for (let index in checked) {
        if (checked[index].nodes) {
          this.gardenList.push(checked[index].id)
          flag++
        } else {
          this.staffList.push(checked[index].id)
          this.staffNameList.push(checked[index].text)
        }
      }
      if (flag === 0) {
        this.garden = ''
      } else if (flag === 1) {
        this.garden = checked[0].id
      } else {
        this.garden = undefined
      }
    },
    // 小区\负责人选择
    clickDeal(currentObj, treeStatus) {
      // 用于：父子节点严格互不关联时，父节点勾选变化时通知子节点同步变化，实现单向关联。
      let selected = treeStatus.checkedKeys.indexOf(currentObj.ssKey) // -1未选中
      // 选中
      if (selected != -1) {
        // 子节点只要被选中父节点就被选中
        this.selectedParent(currentObj, true)
        // 子节点单选
        if (currentObj.nodes) {
        } else {
          this.selectedOneChild(currentObj)
        }
      } else {
        // 未选中 处理子节点全部未选中、父节点未选中
        if (currentObj.nodes) {
          if (currentObj.nodes.length > 0) {
            let currentNode = this.$refs.treeGardenStaff.getNode(currentObj)
            this.$refs.treeGardenStaff.setChecked(currentNode.parent, false)
            this.uniteChildSame(currentNode, false)
          }
        } else {
          this.selectedParent(currentObj, false)
        }
      }
    },
    // 统一处理子节点为相同的勾选状态
    uniteChildSame(treeList, isSelected) {
      for (let i = 0; i < treeList.childNodes.length; i++) {
        this.$refs.treeGardenStaff.setChecked(treeList.childNodes[i], isSelected)
      }
    },
    // 统一处理父节点为选中
    selectedParent(currentObj, isSelected) {
      let currentNode = this.$refs.treeGardenStaff.getNode(currentObj)
      if (currentNode.parent.key != undefined) {
        this.$refs.treeGardenStaff.setChecked(currentNode.parent, isSelected)
      }
    },
    // 子节点仅有一个可被选中
    selectedOneChild(currentObj) {
      let nodes = this.$refs.treeGardenStaff.getNode(currentObj)
      let treeList = this.$refs.treeGardenStaff.getNode(nodes.parent.key)
      for (let i = 0; i < treeList.childNodes.length; i++) {
        if (treeList.childNodes[i].key != currentObj.ssKey) { 
          if (treeList.childNodes[i].checked === true) {
            this.$refs.treeGardenStaff.setChecked(treeList.childNodes[i], false) 
          }
        }
      }
    },
    // 巡检标准列表tab切换
    handleTabClick(tab, event) {
       this.getPatrolStandard(tab.name, '')
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.checkAll = false
      this.isIndeterminate = false
    },
    // 监听关闭GardenStaffDialog
    handleGardenStaffDialogClosed() {
      this.getCheckedGradanStaff()
    },
    // 监听关闭HouseUnitRoomDialog
    handleHouseUnitRoomDialogClosed() {
      this.getHouseUnitRoomName()
    },
    // 小区/负责人列表
    selectVillage() {
      this.isShowGardenStaff = true
      this.titleGardenStaff = this.$i18n.t('lang.lab_taskVillageList')
    },
    // 巡检标准列表
    selectStandardList() {
      this.isShow = true
      this.title = this.$i18n.t('lang.lab_taskStandardList')
      this.statusCheckAll(this.patrolStandard)
    },
    // 楼号\单元号\房间号列表
    selectHouseUintRoomList() {
      this.isShowHouseUnitRoom = true
      this.titleHouseUnitRoom = this.$i18n.t('lang.lab_theHURList')
    },
    // 确定添加
    addTaskStandard() {
      if (this.patrolStandard.length === 0) {
        this.$message.warning(this.$i18n.t('lang.lab_selectStandardPreview'))
        return
      }
      let temp = {}
      
      for (let index = 0; index < this.patrolNameList.length; index++) {
        for (let count = 0; count < this.patrolStandard.length; count++) {
          if (this.patrolNameList[index].id === this.patrolStandard[count]) {
            this.patrolStandardName.push(this.patrolNameList[index].name)
          }
        }
      }

      temp.patrolList = this.patrolStandard
      temp.patrolNameList = this.patrolStandardName
      temp.houseUnitRoomList = this.theHURSelected
      temp.patrolNamesList = this.patrolStandardName.join(' ')
      temp.houseUnitRoomNameList = this.theHURName.join(' ')
      temp.dutyPersonList = this.staffNameList.join(' ')
      this.ruleForm.PatrolList.push(temp)
      this.patrolStandard = []
      this.patrolStandardName = []
      this.$nextTick(() => {
        this.$refs.treeHouseUnitRoom.setCheckedKeys([])
      })
      this.theHURName = []
       this.PatrolCount = this.PatrolCount + temp.patrolList.length
    },
    // 删除巡检标准一列
    deleteOne(index) {
       if (this.ruleForm.PatrolList[index].flag) {
          this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
           .then(() => {
            console.log(this.ruleForm.PatrolList[index].Qua_Pat_HUR_ShipId)
            this.$delete(`delPatrolInfo/` + this.ruleForm.PatrolList[index].Qua_Pat_HUR_ShipId).then(
              res => {
                if (res && res.errCode === 0) {
                     this.ruleForm.PatrolList.splice(index, 1)
                    let total = 0
                    for (let i = 0; i < this.ruleForm.PatrolList.length; i++) {
                        total = total + this.ruleForm.PatrolList[i].patrolList.length
                    }
                   this.PatrolCount = total
                     this.$message({
                     type: 'success',
                     message: this.$i18n.t('lang.lab_del_success')
                   })
                }
              },
              error => {
                this.$message.error(error)
              }
            )
           })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
        } else {
          this.$confirm(
            this.$i18n.t('lang.lab_taskWarningDelete'),
            this.$i18n.t('lang.lab_prompt'),
            {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          )
          .then(() => { 
            this.ruleForm.PatrolList.splice(index, 1)
            let total = 0
            for (let i = 0; i < this.ruleForm.PatrolList.length; i++) {
                 total = total + this.ruleForm.PatrolList[i].patrolList.length
            }
            this.PatrolCount = total
            console.log(total)
            }).catch(() => {
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
       }
    },
    // 巡检设备列表
    selectPatrolDevice() {
      this.isShow = true
      this.title = this.$i18n.t('lang.lab_taskDeviceList')
    },
    // 巡检路线列表
    selectPatrolPointLine() {
      this.isShow = true
      this.title = this.$i18n.t('lang.lab_taskRouteList')
    },
    // 巡检标准详情
    previewPatrolStandard(id) {
      this.getPatrolStandardById(id)
      this.isPreview = true
      this.titlePreview = this.$i18n.t('lang.lab_taskStandardPreview')
    },
    // 巡检标准列表全选
    handleCheckAllChange(val) {
      if (val) {
        // 当前页面全选
        this.patrolStandard = this.patrolStandard.concat(this.patrolStandardIdList)
      } else {
        // 当前页面全不选
        let temp = []
        for (var i = 0; i < this.patrolStandard.length; i++) {
          if (this.patrolStandardIdList.indexOf(this.patrolStandard[i]) === -1) {
            temp.push(this.patrolStandard[i])
          }
        }
        this.patrolStandard = temp
      }
      // 去重
      let unique = []
      for (var j = 0; j < this.patrolStandard.length; j++) {
        if (unique.indexOf(this.patrolStandard[j]) === -1) {
          unique.push(this.patrolStandard[j])
        }
      }
      this.patrolStandard = unique
    
      this.isIndeterminate = false
    },
    // 巡检标准列表选择
    handleCheckedChange(value) { 
      this.statusCheckAll(value)
    },
    // 巡检标准详情获取
    getPatrolStandardById(id) {
      this.$get(`patrolStandardById/` + id).then(
        res => {
          if (res && res.errCode === 0) {
            this.standardPreview = res
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 巡检路线详情
    previewPatrolPointLine(id) {
      this.getPatrolPointLineById(id)
      this.titlePreview = this.$i18n.t('lang.lab_taskRoutePreview')
    },
    // 巡检路线详情获取
    getPatrolPointLineById(id) {
      this.$get(`patrolPointLineById/` + id).then(
        res => {
          if (res && res.errCode === 0) {
            this.routePreview = res.patrolPointLine
            if (res.patrolPointLine.planarGraphId && res.patrolPointLine.planarGraphId != null) {
              this.getPatrolGraphById(res.patrolPointLine.planarGraphId)
              this.getPointList(
                this.routePreview.gardenId,
                this.routePreview.planarGraphId,
                this.routePreview.patrolTypeId
              )
            } else {
              this.isPreview = true
            }
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 巡检路线-查看点位图
    showGraph(urls) {
      this.getImgUrl = urls
      // 存储图片的宽高
      var img = new Image()
      img.src = this.getImgUrl
      this.left = img.width
      this.top = img.height
      this.isImg = true
    },
    // 巡检路线-查看二维码
    seeQrImg(pointId, msg) {
      this.QrTitle = this.$i18n.t('lang.lab_seeQrCodes')
      this.qrText = msg
      this.qrShowPointId = pointId
      this.showQr = true
    },
    // 获取点位图
    getPatrolGraphById(id) {
      this.$get(`planarGraphById/` + id).then(
        res => {
          if (res && res.errCode === 0) {
            this.routePreviewUrls = res.urls
            this.isPreview = true
          } else {
            this.isPreview = false
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 平面图点位
    getPointList(gardenId, planarGraphId, patrolTypeId) {
      let loading = this.$loading()
      this.$get(
        `/patrolPointList?GardenId=${gardenId}&PlanarGraphId=${planarGraphId}&PatrolTypeId=${patrolTypeId}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.sign = res.pointJsonArray
            if (this.sign.length > 0) {
              for (let i = 0; i < this.sign.length; i++) {
                if (this.sign[i].ptypecss === '/images/patrol/pink.png') {
                  this.sign[i].ptypecss = require('../../../../images/patrol/pink.png')
                } else if (
                  this.sign[i].ptypecss === '/images/patrol/blue.png'
                ) {
                  this.sign[i].ptypecss = require('../../../../images/patrol/blue.png')
                } else if (
                  this.sign[i].ptypecss === '/images/patrol/green.png'
                ) {
                  this.sign[i].ptypecss = require('../../../../images/patrol/green.png')
                } else if (
                  this.sign[i].ptypecss === '/images/patrol/yellow.png'
                ) {
                  this.sign[i].ptypecss = require('../../../../images/patrol/yellow.png')
                } else if (this.sign[i].ptypecss === '/images/patrol/red.png') {
                  this.sign[i].ptypecss = require('../../../../images/patrol/red.png')
                }
              }
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 检查checkbox们
    checkCorn() {
      this.yearCron = '*'
      this.mouthCron = '*'
      this.weekCron = '?'
      this.dayCron = '*'
      this.hourCron = '*'
      this.minuteCron = '0'
      this.cron = ''
      if (this.yearList.length > 0) {
          this.yearCron = this.yearList.join(',')
        }
      if (this.monthList.length > 0) {
        this.mouthCron = this.monthList.join(',')
      }
      if (this.ruleForm.week.length > 0) {
        for (let count = 0; count < this.ruleForm.week.length; count++) {
          let index = this.weeks.findIndex(item => item.value === this.ruleForm.week[count])
          if (index != -1) {
            this.ruleForm.week[count] = this.weeks[index].code
          }
        }     
        this.weekCron = this.ruleForm.week.join(',')
      }
      if (this.ruleForm.day.length > 0) {
        this.dayCron = this.ruleForm.day.join(',')
      }
      if (this.ruleForm.hour.length > 0) {
        this.hourCron = this.ruleForm.hour.join(',')
      }
      if (this.minuteList.length > 0) {
        for (let count = 0; count < this.minuteList.length; count++) {
          if (this.minuteList[count] === '00') {
            this.minuteList[count] = '0'
          }
        }       
        this.minuteCron = this.minuteList.join(',')
      }
      if (this.weekCron != '?') {
        this.dayCron = '?'
      }
      this.cron = '0 ' + this.minuteCron + ' ' + this.hourCron + ' ' + this.dayCron + ' ' + this.mouthCron + ' ' + this.weekCron + ' ' + this.yearCron
    },
    // 保存
    save(formName) {
      // 杜，保存时，如果没选择年份，弹窗提示
        if (this.yearList.length == 0) {
          this.$message.warning(this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_taskYear'))
          return false
        }
      var checkPatrolList = this.ruleForm.PatrolList.length
      for (let i = this.ruleForm.PatrolList.length - 1; i >= 0; i--) {
        if (this.ruleForm.PatrolList[i].flag) {
          this.ruleForm.PatrolList.splice(i, 1)
        }
      }
      this.checkCorn()
      let params = {}
      if (this.isFlag) {
        params.id = this.id
        params.gardenId = this.ruleForm.gardenId
        params.staff = this.ruleForm.dutyPerson
        params.jobFiles = this.ruleForm.jobFiles
      } else {
        // 杜，新增1
        params.staff = this.ruleForm.dutyPerson
        params.files = ''
        if (this.urlList.length > 0) {
          params.files = this.urlList.join(',')
        }
        params.staffIds = ''
        if (this.staffList.length > 0) {
          params.staffIds = JSON.stringify(this.staffList)
        }
        params.gardenIds = ''
        if (this.gardenList.length > 0) {
          params.gardenIds = this.gardenList.join(',')
        }
      }
      params.name = this.ruleForm.name
      params.content = this.ruleForm.content
      params.typeId1 = this.ruleForm.typeId1
      params.typeId2 = this.ruleForm.typeId2
      params.typeId3 = this.ruleForm.typeId3
      params.isInspect = this.ruleForm.isInspect
      params.workDay = this.ruleForm.workDay
      params.year = this.yearCron
      params.mouth = this.mouthCron
      params.week = this.weekCron
      params.day = this.dayCron
      params.hour = this.hourCron
      params.minute = this.minuteCron
      params.cron = this.cron
      params.isSpan = 1
      params.gardenArr = this.ruleForm.gardenId
      params.staffArr = this.ruleForm.dutyPerson
      // params.houseId = this.ruleForm.houseId
      // params.unitId = this.ruleForm.unitId
      // params.roomId = this.ruleForm.roomId
      params.device = ''
      if (this.patrolDevice.length > 0) {
        params.device = this.patrolDevice.join(',')
      }
      params.patrolPointLine = this.ruleForm.patrolPointLine
      params.patrolInfo = JSON.stringify(this.ruleForm.PatrolList)
      if (this.datevalues != []) {
        params.startTs = this.datevalues[0]
        params.endTs = this.datevalues[1]
      } else {
        params.startTs = ''
        params.endTs = ''       
      }
      if (this.ruleForm.cycle === 1) {
        this.rules.day[0].required = false
      } else if (this.ruleForm.cycle === 2) {
        this.rules.week[0].required = false
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // baseBug前端限制
          // 原，1
          // if (checkstaffIds < 1) {
          // 杜，新增1
          if (!this.ruleForm.dutyPerson) {
            this.$message.warning(this.$i18n.t('lang.lab_taskWarningStaff'))
            return false
          }
          if (checkPatrolList < 1) {
            this.$message.warning(this.$i18n.t('lang.lab_taskWarningStandardPreview'))
            return false        
          }
          if (this.isFlag === true) {
            var index = this.$keepAlive.indexOf('/manage/main.quartzJobListInspect')
            if (index > -1) {
              this.$keepAlive.splice(index, 1)
            }
            this.$patch(`/quartzJob/${this.id}`, params).then(
              res => {
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.$router.push({ name: 'taskInspectManageList' })
                }
              },
              error => {
                if (error === null) {
                  this.$message.warning(this.$i18n.t('lang.lab_editError'))
                  this.$router.push({ name: 'taskInspectManageList' })
                } else {
                  this.$message.error(error)
                }
              })
          } else {
            var index = this.$keepAlive.indexOf('/manage/main.quartzJobListInspect')
            if (index > -1) {
              this.$keepAlive.splice(index, 1)
            }
            this.$postJson(`/quartzJob/`, params).then(
              res => {
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.$router.push({ name: 'taskInspectManageList' })
                }
              },
              error => {
                if (error === null) {
                  this.$message.warning(this.$i18n.t('lang.lab_addError'))
                  this.$router.push({ name: 'taskInspectManageList' })
                } else {
                  this.$message.error(error)
                }
              })            
          }
        } else {
          // baseBug前端限制
          // 原，1
          // if (checkstaffIds < 1) {
          // 杜，新增1
          if (!this.ruleForm.dutyPerson) {
            this.$message.warning(this.$i18n.t('lang.lab_taskWarningStaff'))
          } else {
            if (checkPatrolList < 1) {
              this.$message.warning(this.$i18n.t('lang.lab_taskWarningStandardPreview'))    
            }
          }
          return false
        }
      })
    },
    // 返回
    back() {
      this.$router.push({ name: 'taskInspectManageList' })
    },
    // 清空
    resetForm(formName) {
      this.clears = true
      this.$refs.ruleForm.clearValidate()
      this.ruleForm.name = ''
      this.ruleForm.content = ''
      this.ruleForm.cycle = 2
      this.ruleForm.day = [] // 切换星期后日list清空
      this.ruleForm.isInspect = 0
      this.ruleForm.workDay = ''
      this.ruleForm.startTs = ''
      this.ruleForm.endTs = ''
      this.datevalues = [] // 开始结束时间绑定值
      this.fileList = [] // 附件上传
      this.urlList = []// 附件上传
      if (this.isFlag === false || this.isFlag == 'false') {
        this.yearList = [] // 年checkBoxlist
        this.monthList = [] // 月checkBoxlist
        this.ruleForm.week = [] // 周checkBoxlist
        this.ruleForm.day = [] // 天checkBoxlist
        this.ruleForm.hour = [] // 时间checkBoxlist
        this.minuteList = [] // 分钟checkBoxlist
        this.patrolDevice = []
        this.ruleForm.patrolPointLine = ''
      }
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate()
      }, 0)
    },
    // 上传数量超过提醒
    outlimit() {
      this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
    },
    // 移除附件
    handleRemove(e) {
     let list1 = []
     for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i] === e || (this.fileList[i].url && this.fileList[i].url === e)) {

        } else {
          list1.push(this.fileList[i])
        }
     }
      this.fileList = list1
      this.filesChange(this.fileList) 
    },
    // 上传成功
    handleSuccess(file) {
      if (file && file.response) {
        this.fileList.push({
          name: '',
          url: file.response.data[0]
        })
      }
      this.filesChange(this.fileList) 
    },
    // 上传到服务器
    submitUpload() {
      this.$refs.upload.submit()
    },
    filesChange(fileList) {
      this.urlList = []
      for (let i = 0; i < this.fileList.length; i++) {
        this.urlList.push(this.fileList[i].url)
      }
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
  }
}
</script>

<style lang="scss">
.editTask {
  .trees {
    height: 600px;
    overflow-y: auto;
    .el-checkbox {
      width: 20px;
    }
  }
  .trees::-webkit-scrollbar {
    width: 10px;
    height: 1px;
  }
  .trees::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: rgba(144, 147, 153, 0.3);
  }
  .input-width{
    width: 60%;
  }
  .item-input{
    width: 40%;
  }
  .checkbox-group{
    .el-checkbox, .el-checkbox-button__inner, .el-radio {
      width: 40px!important;
    }
  }
  .table-position{
    margin-top: 40px;
    margin-bottom: 40px;
    width: 80%;
    overflow: auto;
  }
  .checkbox-line{
    .el-checkbox, .el-checkbox-button__inner, .el-radio {
      width: 500px;
      margin-left: 20px;
    } 
  }
  .option-color{
    color: #606266;
  }
  .option-text-patrolDevice{
    margin-bottom: 20px!important;
  }
  .option-text-patrolPointLine{
    margin-bottom: 10px!important;
  }
  .el-tabs {
    background-color: white!important; 
  }
  .el-tabs__nav-wrap {
    position: relative!important;
    width: 578px!important;
  }
  .el-tabs__nav-scroll {
    .el-tabs__nav.is-top {
      border: none;
      .el-tabs__item {
        border-left: 1px solid #e4e7ed !important;
        border-right: 1px solid #e4e7ed !important;
      }
    }
  }
  .el-tabs--border-card>.el-tabs__header {
    border-bottom: 0px solid #e4e7ed!important;
  }
  .el-tabs--border-card>.el-tabs__content {
    padding: 0px!important;
  }
  .dialog-form{
    .el-dialog .el-form {
      padding: 10px!important;
    }
  }
  .height_all {
    height: 100px;
  }
  .pointImg {
    position: absolute;
    margin-left: -25px;
    margin-top: -40px;
    width: 40px;
    height: 50px;
    display: block;
  }
  .pointSpan {
    position: absolute;
    color: #f00;
    width: 150px;
    height: 50px;
    span {
      font-weight: 900;
      font-size: 150%;
      color: #f00;
    }
  }
  .getImg {
    width: 700px;
    height: auto;
  }
  .el-dialog--center {
    text-align: left!important;
  }
  .el-dialog__header {
    text-align: center;
  }
  .btnmar {
    margin-right: 20px;
  }
  .upload-width{
    width: 900px;
  }
}
.img {
  width: 80px;
  height: 50px;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 5px;
}
</style>